import { OnInit, Component } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService, NzNotificationService } from 'ng-zorro-antd';

import { GlobalComponent, Tempo, Result, Aziende, Rfid, TimeTable } from '../../environments/global';


@Component({
    selector: 'app-rfid',
    templateUrl: 'rfid-gg.component.html',
    styleUrls: ['rfid-gg.component.scss'],
    providers: [DatePipe]
})
export class RfidGgComponent implements OnInit {
    // TABLE VARS
    dataSet = [];
    public displayData = [...this.dataSet];
    editCache = {};
    sortName = null;
    sortValue = null;
    // COMPONENT VARS
    newTempo: Tempo = { id: new Date(), date: new Date(), userId: '', orderId: '', h: 0 } as Tempo;
    public newCodeError: string = 'validating';
    isLoading: boolean = true;
    isSpinning: boolean = false;
    companyData: Array<string> = Aziende;
    selectedCompany: string;
    selectedMonth: Date;
    orderData = [];
    userData = [];


    constructor(
        public g: GlobalComponent,
        private notification: NzNotificationService,
        public datepipe: DatePipe,
        private message: NzMessageService) {
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 5;
        this.g.homeTitle = 'Tabella Ingressi giornaliera';
    }
    loadData() {
        this.isSpinning = true;

        const query: string = 'Select ' +
            'chk_rfid.code, ' +
            'chk_users.name, ' +
            'chk_users.surname, ' +
            'chk_users.company, ' +
            'chk_rfid.time_enter, ' +
            'chk_rfid.time_exit, ' +
            'chk_rfid.marked ' +
            'FROM ' +
            'chk_rfid Left Join ' +
            'chk_users On chk_users.code = chk_rfid.code ' +
            'ORDER BY chk_rfid.code, chk_rfid.time_enter';
        console.log(query);
        
        return this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                this.isSpinning = false;

                // ################ PACK DATA
                let newTime: number;
                let lastTime = 0;
                let lastCode = -1;
                let lastCompany = '';
                let lastName = '';
                let lastSurname = '';
                let totHrs = 0;
                let lastMark = 0;
                let dtDiff = 0;
                res.data.forEach(d => {
                    if (d.code !== lastCode) {
                        // INSERT PREV
                        if (totHrs !== 0) {
                            // console.log('ADD NEW DIP', lastCode);
                            this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
                        }
                        lastCode = d.code;
                        lastName = d.name;
                        lastSurname = d.surname;
                        lastCompany = d.company;
                        lastTime = 0;
                        totHrs = 0;
                        lastMark = 1;
                    }
                    lastMark = lastMark * d.marked;
                    if (d.time_exit !== 0) {
                        dtDiff = this.g.diffTime(d.time_enter, d.time_exit); // Math.round(Math.abs(d.time_exit - d.time_enter) / 36e5 * 100) / 100;
                    } else {
                        dtDiff = 0;
                    }
                    newTime = new Date(d.time_enter).setHours(0, 0, 0, 0);
                    if (lastTime !== newTime) {
                        if (totHrs !== 0) {
                            // console.log('ADD NEW DAY', lastCode, lastTime);
                            this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
                        }
                        lastTime = newTime;
                        totHrs = dtDiff;
                    } else {
                        totHrs += dtDiff;
                    }
                    // console.log('DIFF', d.time_enter, d.time_exit, dtDiff);
                });
                if (totHrs !== 0) {
                    this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
                }
                // this.sort({ key: 'time', value: 'ascending' });
                this.dataSet.sort(function(a, b) {
                    return b['time'] - a['time'] || a['anem'] - b['name'];
                });
                this.updateEditCache();
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
            });
    }

    addRow(code: number, compamy: string, name: string, surname: string, time: number, totH: number, marked: number) {
        this.dataSet.push({
            code: code,
            company: compamy, name: name, surname: surname,
            time: time,
            totH: totH,
            marked: marked
        });
    }


    sort(sort: { key: string, value: string }): void {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [... this.dataSet.sort((a, b) => (this.sortValue === 'ascend') ?
                (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
        } else {
            this.displayData = [...this.dataSet];
        }
    }

    deleteRow(code: string, enter: number): void {
        const index = this.dataSet.findIndex(item => item.code === code);
        const query: string = 'DELETE FROM chk_rfid WHERE '
            + '`code`= ' + code + ' AND '
            + '`time_enter`= ' + enter.toString();
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                if (res.error === false) {
                    this.dataSet.splice(index, 1);
                    this.message.success('Cancellazione completata con successo!');
                    this.updateEditCache();
                } else {
                    this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                    console.log(res);
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
            });
    }

    updateEditCache(): void {
        if (this.dataSet != null) {
            this.dataSet.forEach(item => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
}
